module.exports = __webpack_public_path__ + "img/proyectos.27843a95.webp";